import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import store from "@/store";

export default {
  name: "CyclesManagement",
  components: {
    VPagination,
  },
  data() {
    return {
      cycles: [],
      editIndex: null,
      editableRow: null,
      protocolId: "",
      idToken: "",
      pageindex: 1,
      pageSize: 10,
      SortProperty: "cycleName",
      sortorder: 0,
      totalPages: 1,
      totalCount: 0,
      currentPage: 1,
      loadNextPage: false,
      baseurl: process.env.VUE_APP_Service_URL,
      validationErrors: {},
      armList: [],
      cycleTypeList: [],
      protocol: {},
      isAddingNew: false,
      newRow: {
        cycleName: "",
        cyclePrefix: "",
        armCode: "",
        cycleDuration: "",
        parentCycle: "",
        cycleType: "",
        cycleOrder: "",
        isRepeatable: false,
        minRepeats: "",
        maxRepeats: "",
      },
      newRowErrors: {},
    };
  },
  async mounted() {
    this.idToken = store.getters.getIdToken;
    this.protocolId = this.$route.query.id;
    await this.getProtocolbyId();
    if (this.protocolId) {
      await this.listCycles(this.protocolId);
    }
  },
  methods: {
    async listCycles(protocolId) {
      await axios
        .get(
          `${this.baseurl}/management/studyprotocol/listdacycles?protocolId=${this.protocolId}&pageindex=${this.pageindex}&pagesize=${this.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.sortorder}`,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.cycles = res.data.results;
          this.totalCount = res.data.totalCount;
          this.totalPages = Math.ceil(res.data.totalCount / this.pageSize);
        })
        .catch((err) => console.log("Error in fetching cycles:", err));
    },
    editRow(index, cycle) {
      this.editIndex = index;
      this.editableRow = { ...cycle };
      this.validationErrors = {};
    },
    validateRow() {
      this.validationErrors = {};
      if (!this.editableRow.cycleName) {
        this.validationErrors.cycleName = "Cycle Name is required.";
      }
     
      return Object.keys(this.validationErrors).length === 0;
    },
    async updateRow(daCyclesId) {
      try {
        if (!this.editableRow) {
          console.error("No editable row found.");
          return;
        }

        if (!this.validateRow()) {
          return;
        }

        const updateData = {
          daCyclesId: daCyclesId,
          protocolRefId: this.protocolId,
          studyId: this.editableRow.studyId,

          cycleId: this.editableRow.cycleId,
          cycleName: this.editableRow.cycleName,
          cyclePrefix: this.editableRow.cyclePrefix,
          armCode: this.editableRow.armCode,

          cycleDuration: Number(this.editableRow.cycleDuration) || 0,
          parentCycle: Number(this.editableRow.parentCycle) || 0,
          cycleType: this.editableRow.cycleType,

          cycleOrder: Number(this.editableRow.cycleOrder) || 0,
          isRepeatable: this.editableRow.isRepeatable,

          maxRepeats: Number(this.editableRow.maxRepeats) || 0,
          minRepeats: Number(this.editableRow.minRepeats) || 0,
        };

        const response = await axios.put(
          `${this.baseurl}/management/studyprotocol/updatedacycles`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Update response:", response.data);

        await this.getProtocolbyId();
        this.cancelEdit();
        await this.listCycles(this.protocolId);

        alert("Cycle details updated successfully.");
      } catch (err) {
        console.error("Error during updateRow API call:", err);
        alert("Failed to update cycle. Please try again.");
      }
    },
    cancelEdit() {
      this.editIndex = null;
      this.editableRow = null;
    },
    clearFieldError(fieldName) {
      if (this.validationErrors[fieldName]) {
        delete this.validationErrors[fieldName];
      }
    },
    async loadPage(page) {
      this.currentPage = page;
      this.pageindex = page;
      this.loadNextPage = true;
      await this.listCycles(this.protocolId);
    },
  

    async deleteRow(cycleId) {
      try {
        const confirmation = confirm("Are you sure you want to delete this cycle?");
        if (!confirmation) return;

        const response = await axios.delete(
          `${this.baseurl}/management/studyprotocol/deletebyid?collectionName=DaScrape_Cycles&id=${cycleId}`,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Delete response:", response.data);
        await this.listCycles(this.protocolId);
        if (this.cycles.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          this.pageindex = this.currentPage;
          await this.listCycles(this.protocolId);
        }
        alert("Cycle deleted successfully.");
      } catch (error) {
        console.error("Error during cycle delete API call:", error);
        alert("Failed to delete the cycle. Please try again.");
      }
    },
    async getProtocolbyId() {
      const token = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/document/getprotocolbyid?protocolId=${this.protocolId}`,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.protocol = res.data;
        })
        .catch((err) => console.log("error in get protocol by id", err));
    },
    addNewRow() {
      this.isAddingNew = true;
      this.newRow = {
        cycleName: "",
        cyclePrefix: "",
        armCode: "",
        cycleDuration: "",
        parentCycle: "",
        cycleType: "",
        cycleOrder: "",
        isRepeatable: false,
        minRepeats: "",
        maxRepeats: "",
      };
      this.newRowErrors = {};
      // Cancel any active inline edit
      this.editIndex = null;
      this.editableRow = null;
    },

    cancelNewRow() {
      this.isAddingNew = false;
      this.newRowErrors = {};
    },

    clearNewFieldError(fieldName) {
      if (this.newRowErrors[fieldName]) {
        delete this.newRowErrors[fieldName];
      }
    },

    validateNewRow() {
      this.newRowErrors = {};
      if (!this.newRow.cycleName) {
        this.newRowErrors.cycleName = "Cycle Name is required.";
      }
      return Object.keys(this.newRowErrors).length === 0;
    },

    async saveNewRow() {
      if (!this.validateNewRow()) return;

      try {
        const payload = {
          collectionName: "DaScrape_Cycles",
          data: {
            protocolRefId: this.protocolId,
            studyId: this.protocol.studyId,
            cycleName: this.newRow.cycleName,
            cyclePrefix: this.newRow.cyclePrefix,
            armCode: this.newRow.armCode,
            cycleDuration: Number(this.newRow.cycleDuration) || 0,
            parentCycle: Number(this.newRow.parentCycle) || 0,
            cycleType: this.newRow.cycleType,
            cycleOrder: Number(this.newRow.cycleOrder) || 0,
            isRepeatable: this.newRow.isRepeatable,
            minRepeats: Number(this.newRow.minRepeats) || 0,
            maxRepeats: Number(this.newRow.maxRepeats) || 0,
          },
        };

        await axios.post(
          `${this.baseurl}/management/studyprotocol/genericinsert`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.isAddingNew = false;
        this.newRowErrors = {};

        await this.listCycles(this.protocolId);

        alert("Cycle created successfully.");
      } catch (err) {
        console.error("Error creating cycle:", err);
        alert("Failed to create cycle. Please try again.");
      }
    }
  },
};